/* Poolside Social — theme scripts */
(function () {
'use strict';
var PS = window.PS || {};
var $ = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
/* ---------- money ---------- */
function formatMoney(cents, format) {
if (typeof cents === 'string') cents = cents.replace('.', '');
format = format || PS.moneyFormat || '${{amount}}';
function withDelimiters(n, precision, thousands, decimal) {
precision = precision == null ? 2 : precision;
if (isNaN(n) || n == null) return '0';
n = (n / 100.0).toFixed(precision);
var parts = n.split('.');
var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousands || ','));
var c = parts[1] ? (decimal || '.') + parts[1] : '';
return dollars + c;
}
var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
var key = m ? m[1] : 'amount';
var value;
switch (key) {
case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
default: value = withDelimiters(cents, 2);
}
return format.replace(/\{\{\s*\w+\s*\}\}/, value);
}
PS.formatMoney = formatMoney;
/* offer maths: lowest-priced item(s) free in each full group */
function offerSaving(prices) {
var buy = PS.offerBuy || 2, get = PS.offerGet || 1, size = buy + get;
var sorted = prices.slice().sort(function (a, b) { return b - a; });
var free = 0;
for (var i = 0; i + size <= sorted.length; i += size) {
for (var j = i + buy; j < i + size; j++) free += sorted[j];
}
return free;
}
PS.offerSaving = offerSaving;
function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
/* ---------- toast ---------- */
var toastEl;
function toast(msg) {
if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
toastEl.textContent = msg;
toastEl.classList.add('is-show');
clearTimeout(toastEl._t);
toastEl._t = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2600);
}
/* ---------- overlay / panels ---------- */
var overlay = $('[data-overlay]');
var openPanel = null, lastFocus = null;
function open(panel) {
if (!panel) return;
if (openPanel && openPanel !== panel) close(openPanel, true);
lastFocus = document.activeElement;
panel.classList.add('is-open');
panel.setAttribute('aria-hidden', 'false');
if (overlay) overlay.hidden = false;
document.documentElement.style.overflow = 'hidden';
openPanel = panel;
var f = panel.querySelector('button, a, input, select');
setTimeout(function () { (f || panel).focus(); }, 60);
}
function close(panel, keepOverlay) {
panel = panel || openPanel;
if (!panel) return;
panel.classList.remove('is-open');
panel.setAttribute('aria-hidden', 'true');
if (!keepOverlay) {
if (overlay) overlay.hidden = true;
document.documentElement.style.overflow = '';
if (lastFocus && lastFocus.focus) lastFocus.focus();
}
if (openPanel === panel) openPanel = null;
}
PS.open = open; PS.close = close;
if (overlay) overlay.addEventListener('click', function () { close(); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openPanel) close(); });
document.addEventListener('click', function (e) {
var c = e.target.closest('[data-close]');
if (c) { close(c.closest('.drawer, .modal, .mobile-nav, .filter-drawer')); }
});
/* ---------- header ---------- */
var header = $('.site-header');
if (header) {
var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 10); };
window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
}
document.addEventListener('click', function (e) {
if (e.target.closest('[data-menu-open]')) { e.preventDefault(); open($('[data-mobile-nav]')); }
var s = e.target.closest('[data-search-toggle]');
if (s) {
e.preventDefault();
var bar = $('[data-search-bar]');
if (bar) { bar.hidden = !bar.hidden; if (!bar.hidden) $('input', bar).focus(); }
}
});
/* ---------- cart ---------- */
var drawer = $('[data-cart-drawer]');
var upsell = null;
try { var uj = $('[data-upsell-json]'); if (uj) upsell = JSON.parse(uj.textContent); } catch (err) { upsell = null; }
function fetchCart() { return fetch(PS.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
function offerState(count) {
  var size = PS.offerQty || 3;
  var inGroup = count % size;
  var rem = size - inGroup;
  var msg, pct;
  if (count === 0) { msg = 'Add items to unlock your offer.'; pct = 0; }
  else if (inGroup === 0) { msg = 'Offer unlocked! Savings applied.'; pct = 100; }
  else if (rem <= (PS.offerGet || 1)) { msg = 'Almost there! Add ' + rem + ' more to unlock your offer.'; pct = inGroup / size * 100; }
  else { msg = 'Add ' + rem + ' more to unlock your offer.'; pct = inGroup / size * 100; }
  return { msg: msg, pct: pct, inGroup: inGroup, size: size, complete: count > 0 && inGroup === 0 };
}
function renderOfferBoxes(cart) {
var st = offerState(cart.item_count);
$$('[data-offer-msg]').forEach(function (el) { el.textContent = st.msg; });
$$('[data-offer-bar]').forEach(function (el) { el.style.width = st.pct + '%'; });
$$('[data-offer-count]').forEach(function (el) { el.textContent = (st.complete ? st.size : st.inGroup) + ' of ' + st.size; });
$$('[data-offer-slots]').forEach(function (wrap) {
var slots = $$('.offer-slot', wrap);
// flatten the latest items by quantity
var imgs = [];
cart.items.forEach(function (it) { for (var q = 0; q < it.quantity; q++) imgs.push(it); });
var filled = st.complete ? st.size : st.inGroup;
var recent = imgs.slice(Math.max(0, imgs.length - filled));
slots.forEach(function (s, i) {
var it = recent[i];
s.classList.toggle('is-filled', !!it);
if (it) s.innerHTML = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' + '" alt="' + escapeHtml(it.product_title) + '">' : escapeHtml(it.product_title);
else s.innerHTML = s.getAttribute('data-empty') || '';
});
});
}
function renderCart(cart) {
$$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
renderOfferBoxes(cart);
if (!drawer) return;
var body = $('[data-cart-body]', drawer), foot = $('[data-cart-foot]', drawer);
$('[data-cart-count-label]', drawer).textContent = '(' + cart.item_count + ')';
if (!cart.item_count) {
body.innerHTML = '<div class="drawer__empty"><div class="h2" style="font-size:28px">Your Bag is empty.</div><p>Looks like you have not picked anything yet. Explore our latest styles and find something you love.</p><a class="btn btn--lemon" href="' + PS.routes.root + 'collections/all">Start Shopping</a></div>' + upsellHtml(cart);
foot.hidden = true;
return;
}
var html = cart.items.map(function (it, idx) {
var free = it.final_line_price < it.original_line_price;
var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return escapeHtml(o.value); }).join(' / ');
return '<div class="line">' +
'<a class="line__img" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy" width="88" height="108">' : '') + '</a>' +
'<div><a class="line__title" href="' + it.url + '">' + escapeHtml(it.product_title) + '</a>' +
(opts ? '<div class="line__meta">' + opts + '</div>' : '') +
(free ? '<span class="line__free">Our shout</span>' : '') +
'<div class="line__qty"><button type="button" data-line="' + (idx + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + (idx + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
'<button type="button" class="line__remove" data-line="' + (idx + 1) + '" data-qty="0">Remove</button></div>' +
'<div class="line__price">' + (free ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '') + formatMoney(it.final_line_price) + '</div>' +
'</div>';
}).join('');
body.innerHTML = html + upsellHtml(cart);
foot.hidden = false;
var disc = cart.original_total_price - cart.total_price;
$('[data-cart-original]', drawer).textContent = formatMoney(cart.original_total_price);
$('[data-cart-discount-row]', drawer).hidden = disc <= 0;
$('[data-cart-discount]', drawer).textContent = '−' + formatMoney(disc);
$('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
}
function upsellHtml(cart) {
if (!upsell || !upsell.products || !upsell.products.length) return '';
var st = offerState(cart.item_count);
var inCart = cart.items.map(function (i) { return i.url.split('?')[0]; });
var items = upsell.products.filter(function (p) { return inCart.indexOf(p.url) === -1 && p.variants.length; }).slice(0, 8);
if (!items.length) return '';
var heading = st.inGroup === st.size - 1 ? upsell.heading + ' — it’s on us' : 'Complete the look';
return '<div class="upsell"><h3>' + escapeHtml(heading) + '</h3><div class="upsell__row">' + items.map(function (p) {
var sel = p.variants.length > 1 || p.variants[0].title !== 'Default Title'
? '<select aria-label="Choose option for ' + escapeHtml(p.title) + '" data-upsell-select>' + p.variants.map(function (v) { return '<option value="' + v.id + '">' + escapeHtml(v.title) + '</option>'; }).join('') + '</select>'
: '<input type="hidden" data-upsell-select value="' + p.variants[0].id + '">';
return '<div class="upsell__item"><a class="slot__img" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</a><p>' + escapeHtml(p.title) + '</p><p>' + formatMoney(p.price) + '</p>' + sel + '<button type="button" data-upsell-add>Add</button></div>';
}).join('') + '</div></div>';
}
function refreshCart(openIt) {
return fetchCart().then(function (cart) { renderCart(cart); if (openIt) open(drawer); return cart; });
}
PS.refreshCart = refreshCart;
function addItems(items, btn) {
var label;
if (btn) { label = btn.innerHTML; btn.disabled = true; btn.innerHTML = '<span class="spinner"></span>'; }
return fetch(PS.routes.root + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items: items })
}).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
.then(function () { return refreshCart(true); })
.catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, that couldn’t be added.'); })
.then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
}
PS.addItems = addItems;
document.addEventListener('click', function (e) {
var t;
if ((t = e.target.closest('[data-cart-open]'))) { e.preventDefault(); refreshCart(true); return; }
if ((t = e.target.closest('[data-line]')) && drawer && drawer.contains(t)) {
fetch(PS.routes.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +t.getAttribute('data-line'), quantity: Math.max(0, +t.getAttribute('data-qty')) }) })
.then(function (r) { return r.json(); }).then(renderCart);
return;
}
if ((t = e.target.closest('[data-upsell-add]'))) {
var box = t.closest('.upsell__item'); var sel = $('[data-upsell-select]', box);
addItems([{ id: +sel.value, quantity: 1 }], t); return;
}
if ((t = e.target.closest('[data-quick-toggle]'))) {
var sizes = $('[data-quick-sizes]', t.closest('[data-card]'));
$$('[data-quick-sizes]').forEach(function (s) { if (s !== sizes) s.hidden = true; });
sizes.hidden = !sizes.hidden; t.setAttribute('aria-expanded', String(!sizes.hidden)); return;
}
if ((t = e.target.closest('[data-quick-add]'))) {
addItems([{ id: +t.getAttribute('data-quick-add'), quantity: 1 }], t.classList.contains('card__quick') ? t : null);
var qs = t.closest('[data-quick-sizes]'); if (qs) qs.hidden = true;
return;
}
if (!e.target.closest('[data-card]')) $$('[data-quick-sizes]').forEach(function (s) { s.hidden = true; });
});
refreshCart(false);
/* ---------- size chart ---------- */
var sizeModal = $('[data-size-modal]');
document.addEventListener('click', function (e) {
var t = e.target.closest('[data-size-open], a[href$="#size-chart"]');
if (t && sizeModal) {
e.preventDefault();
var tab = t.getAttribute('data-size-open') || 'tops';
selectTab(tab);
var picked = t.getAttribute('data-selected-size') || '';
$$('[data-size-row]', sizeModal).forEach(function (r) {
var k = (r.getAttribute('data-size-row') || '').toLowerCase().split('/').map(function (x) { return x.trim(); });
r.classList.toggle('is-selected', !!picked && k.indexOf(picked.toLowerCase()) > -1);
});
open(sizeModal);
}
var tb = e.target.closest('[data-size-tab]');
if (tb) selectTab(tb.getAttribute('data-size-tab'));
var u = e.target.closest('[data-unit-toggle]');
if (u) {
var inches = u.getAttribute('aria-pressed') !== 'true';
u.setAttribute('aria-pressed', String(inches)); u.textContent = inches ? 'Show cm' : 'Show inches';
$$('[data-cm]', sizeModal).forEach(function (td) {
var cm = td.getAttribute('data-cm');
td.textContent = inches ? cm.replace(/\d+(\.\d+)?/g, function (n) { return (parseFloat(n) / 2.54).toFixed(1); }) : cm;
});
$$('th', sizeModal).forEach(function (th) { th.textContent = inches ? th.textContent.replace('(cm)', '(in)') : th.textContent.replace('(in)', '(cm)'); });
}
});
function selectTab(tab) {
if (!sizeModal) return;
$$('[data-size-tab]', sizeModal).forEach(function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-size-tab') === tab)); });
$$('[data-size-table]', sizeModal).forEach(function (t) { t.hidden = t.getAttribute('data-size-table') !== tab; });
}
/* ---------- product page ---------- */
function initProduct(root) {
var dataEl = $('[data-product-json]', root);
if (!dataEl) return;
var product = JSON.parse(dataEl.textContent);
var form = $('[data-product-form]', root);
var idInput = $('input[name="id"]', form);
var atc = $('[data-atc]', root);
var priceEl = $('[data-price]', root);
var sticky = $('[data-sticky-atc]');
function currentOptions() {
return $$('[data-option-group]', root).map(function (g) {
var c = $('input:checked', g); return c ? c.value : null;
});
}
function findVariant(opts) {
return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
}
function updateAvailability(opts) {
$$('[data-option-group]', root).forEach(function (g, gi) {
$$('input', g).forEach(function (inp) {
var test = opts.slice(); test[gi] = inp.value;
var v = findVariant(test);
var lab = inp.nextElementSibling;
if (lab) lab.classList.toggle('is-unavailable', !v || !v.available);
});
});
}
function update() {
var opts = currentOptions();
var v = findVariant(opts);
$$('[data-option-group]', root).forEach(function (g) {
var c = $('input:checked', g), out = $('[data-option-value]', g);
if (out && c) out.textContent = c.value;
});
updateAvailability(opts);
var sizeBtn = $('[data-size-open]', root);
if (sizeBtn) {
var sg = $('[data-option-group][data-is-size] input:checked', root);
sizeBtn.setAttribute('data-selected-size', sg ? sg.value : '');
}
if (!v) {
atc.disabled = true; atc.querySelector('[data-atc-label]').textContent = 'Unavailable';
if (sticky) $('[data-sticky-btn]', sticky).disabled = true;
return;
}
idInput.value = v.id;
priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? ' <s>' + formatMoney(v.compare_at_price) + '</s>' : '');
atc.disabled = !v.available;
atc.querySelector('[data-atc-label]').textContent = v.available ? 'Add to bag' : 'Sold out';
if (sticky) {
$('[data-sticky-price]', sticky).textContent = formatMoney(v.price);
var sb = $('[data-sticky-btn]', sticky); sb.disabled = !v.available; sb.textContent = v.available ? 'Add to bag' : 'Sold out';
}
if (v.featured_media_id) goToMedia(v.featured_media_id);
var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
window.history.replaceState({}, '', url.toString());
var bnpl = $('[data-bnpl-amount]', root); if (bnpl) bnpl.textContent = formatMoney(Math.round(v.price / 4));
root.dispatchEvent(new CustomEvent('ps:variant', { detail: v, bubbles: true }));
}
root.addEventListener('change', function (e) { if (e.target.closest('[data-option-group]')) update(); });
var qtyInput = $('[data-qty-input]', root);
root.addEventListener('click', function (e) {
var q = e.target.closest('[data-qty-step]');
if (q && qtyInput) { qtyInput.value = Math.max(1, (+qtyInput.value || 1) + +q.getAttribute('data-qty-step')); }
});
form.addEventListener('submit', function (e) {
e.preventDefault();
addItems([{ id: +idInput.value, quantity: Math.max(1, +(qtyInput ? qtyInput.value : 1)) }], atc);
});
if (sticky) {
$('[data-sticky-btn]', sticky).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
if ('IntersectionObserver' in window) {
new IntersectionObserver(function (en) { sticky.classList.toggle('is-show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(atc);
}
}
/* gallery */
var track = $('[data-gallery-track]', root);
var thumbs = $$('[data-thumb]', root);
var dots = $$('[data-dot]', root);
function goToMedia(mediaId) {
var slide = $('[data-media-id="' + mediaId + '"]', track);
if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
}
if (track) {
thumbs.forEach(function (t) { t.addEventListener('click', function () { goToMedia(t.getAttribute('data-thumb')); }); });
var syncActive = function () {
var idx = Math.round(track.scrollLeft / track.clientWidth);
thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
};
track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(syncActive, 60); }, { passive: true });
$$('[data-gallery-step]', root).forEach(function (b) {
b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * +b.getAttribute('data-gallery-step'), behavior: 'smooth' }); });
});
track.addEventListener('click', function (e) {
var img = e.target.closest('img'); if (!img) return;
var lb = document.createElement('div'); lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-label', 'Image zoom');
lb.innerHTML = '<img src="' + (img.getAttribute('data-zoom') || img.currentSrc) + '" alt="' + escapeHtml(img.alt) + '"><button type="button" aria-label="Close zoom"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round"><path d="M6 6 L18 18 M18 6 L6 18"/></svg></button>';
lb.addEventListener('click', function () { lb.remove(); });
document.body.appendChild(lb); $('button', lb).focus();
});
}
/* description → accordions */
var desc = $('[data-description-source]', root);
var accWrap = $('[data-description-acc]', root);
if (desc && accWrap) {
var nodes = Array.prototype.slice.call(desc.childNodes);
var sections = [{ title: 'The details', nodes: [] }];
nodes.forEach(function (n) {
if (n.nodeType === 1) {
var txt = n.textContent.trim();
var isHeading = /^H[1-6]$/.test(n.tagName) || (n.tagName === 'P' && n.children.length === 1 && n.firstElementChild.tagName === 'STRONG' && n.firstElementChild.textContent.trim() === txt && txt.length < 40 && !/\.$/.test(txt));
if (isHeading) { sections.push({ title: txt.replace(/:$/, ''), nodes: [] }); return; }
}
sections[sections.length - 1].nodes.push(n);
});
sections = sections.filter(function (s) { return s.nodes.some(function (n) { return n.textContent.trim(); }); });
accWrap.innerHTML = sections.map(function (s, i) {
var tmp = document.createElement('div'); s.nodes.forEach(function (n) { tmp.appendChild(n.cloneNode(true)); });
$$('[class]', tmp).forEach(function (el) { el.removeAttribute('class'); });
return '<details' + (i === 0 ? ' open' : '') + '><summary>' + escapeHtml(s.title) + '<span class="plus" aria-hidden="true">+</span></summary><div class="acc__body">' + tmp.innerHTML + '</div></details>';
}).join('');
desc.remove();
}
update();
}
$$('[data-product-root]').forEach(initProduct);
/* ---------- make it a round (PDP cross-sell) ---------- */
function initMix(root) {
function calc() {
var prices = [], items = [];
$$('[data-mix-item]', root).forEach(function (it) {
var cb = $('input[type="checkbox"]', it);
var on = !cb || cb.checked;
it.classList.toggle('is-off', !on);
if (!on) return;
var sel = $('[data-mix-select]', it);
var opt = sel.options ? sel.options[sel.selectedIndex] : null;
var price = opt ? +opt.getAttribute('data-price') : +sel.getAttribute('data-price');
prices.push(price); items.push({ id: +sel.value, quantity: 1 });
});
var total = prices.reduce(function (a, b) { return a + b; }, 0);
var save = offerSaving(prices);
$('[data-mix-total]', root).textContent = formatMoney(total);
$('[data-mix-save]', root).textContent = save ? '−' + formatMoney(save) : formatMoney(0);
$('[data-mix-pay]', root).textContent = formatMoney(total - save);
$('[data-mix-count]', root).textContent = items.length;
root._items = items;
}
root.addEventListener('change', calc);
var mainRoot = $('[data-product-root]');
if (mainRoot) mainRoot.addEventListener('ps:variant', function (e) {
var sel = $('[data-mix-main]', root);
if (sel) { sel.value = e.detail.id; sel.setAttribute('data-price', e.detail.price); }
var lab = $('[data-mix-main-label]', root); if (lab) lab.textContent = e.detail.title;
calc();
});
$('[data-mix-add]', root).addEventListener('click', function (e) { if (root._items && root._items.length) addItems(root._items, e.currentTarget); });
calc();
}
$$('[data-mix]').forEach(initMix);
/* ---------- recommendations ---------- */
$$('[data-recs]').forEach(function (el) {
var url = el.getAttribute('data-url');
if (!url) return;
fetch(url).then(function (r) { return r.text(); }).then(function (text) {
var tmp = document.createElement('div'); tmp.innerHTML = text;
var inner = tmp.querySelector('[data-recs]');
if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML; else el.closest('section') && (el.closest('section').hidden = true);
});
});
/* ---------- build your round (homepage) ---------- */
function initRound(root) {
var data = JSON.parse($('[data-round-json]', root).textContent);
var state = data.slots.slice(); // product objects
var swapIndex = 0;
var picker = $('[data-round-picker]', root);
function productById(h) { return data.pool.find(function (p) { return p.handle === h; }) || data.slots.find(function (p) { return p && p.handle === h; }); }
function variantSelect(p, i) {
var avail = p.variants.filter(function (v) { return v.available; });
if (avail.length === 1 && avail[0].title === 'Default Title') return '<input type="hidden" data-round-select value="' + avail[0].id + '" data-price="' + avail[0].price + '">';
return '<select data-round-select aria-label="Choose size for ' + escapeHtml(p.title) + '">' + avail.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + escapeHtml(v.title) + '</option>'; }).join('') + '</select>';
}
function render() {
var prices = state.map(function (p) { return p ? p.price : 0; });
var sorted = prices.slice().sort(function (a, b) { return a - b; });
var freePrice = (state.length >= PS.offerQty && state.every(Boolean)) ? sorted[0] : null;
var freeIdx = freePrice == null ? -1 : prices.lastIndexOf(freePrice);
$$('[data-slot]', root).forEach(function (el, i) {
var p = state[i];
var isFree = i === freeIdx;
el.classList.toggle('slot--free', isFree);
if (!p) { el.innerHTML = '<div class="slot__label">Slot ' + (i + 1) + '</div><button type="button" class="btn btn--sm btn--outline" data-swap="' + i + '">Pick a piece</button>'; return; }
el.innerHTML = '<div class="slot__label">Slot ' + (i + 1) + (isFree ? ' · Our shout' : '') + '</div>' +
'<a class="slot__img" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</a>' +
'<a class="slot__title" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
'<div class="slot__price">' + (isFree ? '<s>' + formatMoney(p.price) + '</s> <strong>FREE</strong>' : formatMoney(p.price)) + '</div>' +
variantSelect(p, i) +
'<button type="button" class="slot__swap" data-swap="' + i + '">Swap it</button>' +
(isFree ? '<span class="sticker">Free!</span>' : '');
});
calc();
}
function calc() {
var items = [], prices = [];
$$('[data-slot]', root).forEach(function (el) {
var s = $('[data-round-select]', el); if (!s) return;
var price = s.options ? +s.options[s.selectedIndex].getAttribute('data-price') : +s.getAttribute('data-price');
prices.push(price); items.push({ id: +s.value, quantity: 1 });
});
var total = prices.reduce(function (a, b) { return a + b; }, 0), save = offerSaving(prices);
$('[data-round-total]', root).textContent = formatMoney(total);
$('[data-round-save]', root).textContent = '−' + formatMoney(save);
$('[data-round-pay]', root).textContent = formatMoney(total - save);
root._items = items;
var add = $('[data-round-add]', root); add.setAttribute('aria-disabled', String(items.length < PS.offerQty));
}
root.addEventListener('change', function (e) { if (e.target.matches('[data-round-select]')) calc(); });
root.addEventListener('click', function (e) {
var sw = e.target.closest('[data-swap]');
if (sw) { swapIndex = +sw.getAttribute('data-swap'); open(picker); return; }
var pk = e.target.closest('[data-pick]');
if (pk) { state[swapIndex] = productById(pk.getAttribute('data-pick')); close(picker); render(); return; }
var rc = e.target.closest('[data-round-preset]');
if (rc) {
var hs = rc.getAttribute('data-round-preset').split(',');
state = hs.map(productById);
$$('[data-round-preset]', root).forEach(function (b) { b.classList.toggle('is-active', b === rc); });
render();
$('[data-round-builder]', root).scrollIntoView({ behavior: 'smooth', block: 'center' });
return;
}
var add = e.target.closest('[data-round-add]');
if (add) {
e.preventDefault();
if (!root._items || root._items.length < PS.offerQty) { toast('Fill all ' + PS.offerQty + ' slots first.'); return; }
addItems(root._items, add);
}
});
render();
}
$$('[data-round]').forEach(initRound);
/* ---------- collection filters ---------- */
document.addEventListener('click', function (e) {
if (e.target.closest('[data-filter-open]')) { e.preventDefault(); open($('[data-filter-drawer]')); }
});
$$('[data-sort]').forEach(function (s) {
s.addEventListener('change', function () {
var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
window.location.href = url.toString();
});
});
$$('[data-filter-form]').forEach(function (f) {
f.addEventListener('submit', function () {
$$('input', f).forEach(function (i) { if ((i.type === 'number' || i.type === 'text') && !i.value) i.disabled = true; });
});
});
/* ---------- newsletter success ---------- */
if (window.location.search.indexOf('customer_posted=true') > -1) { setTimeout(function () { toast('You’re on the list. Welcome to the club.'); }, 400); }
})();